module.exports = __webpack_public_path__ + "static/media/pic_friend_2.d1cddbb4.jpg";